export const handlePrimaryCareButtonWithThreeDotsClick = (
  actionId: string,
  orderId: string,
  onOpenSendToPlanModal?: (
    orderId: string,
    modalType?: "send_to_plan" | "retry_qa" | "fetch_qa",
  ) => void,
  onNavigate?: (path: string) => void,
  onOpenRerunModal?: (orderId: string, rerunType: string) => void,
  onOpenReportPrescriptionModal?: (orderId: string) => void,
  onOpenReportMedicationModal?: (orderId: string) => void,
) => {
  switch (actionId) {
    case "send_to_plan":
      onOpenSendToPlanModal?.(orderId, "send_to_plan");
      break;
    case "fetch_qa":
      onOpenSendToPlanModal?.(orderId, "fetch_qa");
      break;
    case "retry_qa":
      onOpenSendToPlanModal?.(orderId, "retry_qa");
      break;
    case "view_clinical":
      onNavigate?.(`/pharma-pa-worklists/pharma-pa-questionaire/${orderId}`);
      break;
    case "rerun_from_onco_emr":
      onOpenRerunModal?.(orderId, "onco-emr");
      break;
    case "rerun_from_cmm":
      onOpenRerunModal?.(orderId, "cmm");
      break;
    case "report_prescription_inaccuracy":
      onOpenReportPrescriptionModal?.(orderId);
      break;
    case "report_medication_inaccuracy":
      onOpenReportMedicationModal?.(orderId);
      break;
    case "report_inaccuracy":
      onNavigate?.(
        `/pharma-pa-worklists/pharma-pa-questionaire/${orderId}?openReportInaccuracy=true`,
      );
      break;
    default:
      break;
  }
};
